import {link_area, PUBLIC_PRODUCT_FILTER_CONFIG} from './unit_edit_config_public.js'

const config = {
	link_area,
	
	banner: [{
		tab: '内容设置',
		tips: '控件高度以第一张图片为准',
		content: [{
			type: 'list',
			code: 'list',
			content: [{
				label: '图片地址',
				type: 'image',
				size: '750,0',
				code: 'img_url',
				widthParam: 'img_width',
				heightParam: 'img_height'
			}, {
				label: '链接地址',
				type: 'link',
				code: 'link_url'
			}]
		}]
	}, {
		tab: '其他设置',
		content: [{
			label: '边距',
			type: 'radio',
			code: 'margin',
			options: [{
				name: '无边距',
				value: 0
			}, {
				name: '有边距',
				value: 1
			}]
		}, {
			label: '展示方式',
			type: 'radio',
			code: 'show_type',
			options: [{
				name: '顺序展示',
				value: 1
			}, {
				name: '随机展示',
				value: 2
			}]
		}, {
			label: '自动切换时间',
			type: 'select',
			code: 'switch_interval',
			options: [{
				name: '不自动切换',
				value: 0
			}, {
				name: '3秒',
				value: 3
			}, {
				name: '5秒',
				value: 5
			}, {
				name: '7秒',
				value: 7
			}]
		}]
	}],
	
	cell_icon: [{
		tab: '内容设置',
		tips: '移动端将展示所有图标信息',
		content: [{
			type: 'list',
			code: 'list',
			content: [{
				label: '图片地址',
				type: 'image',
				size: '124,124',
				code: 'img_url'
			}, {
				label: '菜单标题',
				type: 'input',
				code: 'title'
			}, {
				label: '链接地址',
				type: 'link',
				code: 'link_url'
			}]
		}]
	}, {
		tab: '其它设置',
		content: [{
			label: '每行个数',
			type: 'radio',
			code: 'row_number',
			options: [{
				name: '4个',
				value: '4'
			}, {
				name: '5个',
				value: '5'
			}]
		}, {
			label: '背景色',
			type: 'color',
			code: 'background'
		}]
	}],
	
	cell_icon2: [{
		tab: '内容设置',
		content: [{
			type: 'list',
			code: 'list',
			content: [{
				label: '图片地址',
				type: 'image',
				size: '228,128',
				code: 'img_url'
			}, {
				label: '菜单标题',
				type: 'input',
				code: 'title'
			}, {
				label: '链接地址',
				type: 'link',
				code: 'link_url'
			}]
		}]
	}, {
		tab: '其它设置',
		content: [{
			label: '是否显示标题',
			type: 'radio',
			code: 'show_title',
			options: [{
				name: '显示',
				value: '1'
			}, {
				name: '不显示',
				value: '0'
			}]
		}]
	}],
	
	product: [{
		tab: '商品设置',
		content: PUBLIC_PRODUCT_FILTER_CONFIG()
	}, {
		tab: '其它设置',
		content: [{
			label: 'UI主题色',
			type: 'radio',
			code: 'color',
			options: [{
				name: '深色',
				value: '1'
			}, {
				name: '浅色',
				value: '2'
			}]
		}, {
			label: '大图',
			type: 'group',
			code: 'show_banner',
			options: [{
				name: '显示',
				value: '1',
				content: [{
					label: '图片',
					type: 'image',
					code: 'banner_img',
					widthParam: 'banner_width',
					heightParam: 'banner_height'
				}, {
					label: '跳转路径',
					type: 'link',
					code: 'banner_link'
				}]
			}, {
				name: '不显示',
				value: '0'
			}]
		}, {
			label: '标题栏',
			type: 'group',
			code: 'show_title',
			options: [{
				name: '显示',
				value: '1',
				content: [{
					label: '标题图片',
					type: 'image',
					code: 'title_img'
				}, {
					label: '标题文字',
					type: 'input',
					code: 'title_text'
				}, {
					label: '标题字号',
					type: 'number',
					code: 'title_size'
				}, {
					label: '更多文字',
					type: 'input',
					code: 'more_text'
				}, {
					label: '跳转路径',
					type: 'link',
					code: 'more_link'
				}]
			}, {
				name: '不显示',
				value: '0'
			}]
		}, {
			label: '特价标签',
			type: 'radio',
			code: 'price_tag',
			options: [{
				name: '不显示',
				value: '0'
			}, {
				name: '显示',
				value: '1'
			}]
		}, {
			label: '背景色',
			type: 'color',
			code: 'background'
		}]
	}],
	
	roll_icon: [{
		tab: '内容设置',
		content: [{
			label: '菜单标题',
			type: 'radio',
			code: 'show_list_title',
			options: [{
				name: '显示',
				value: '1'
			}, {
				name: '不显示',
				value: '0'
			}]
		},{
			type: 'list',
			code: 'list',
			content: [{
				label: '图片地址',
				type: 'image',
				code: 'img_url',
				widthParam: 'img_width',
				heightParam: 'img_height'
			}, {
				label: '菜单标题',
				type: 'input',
				code: 'title'
			}, {
				label: '链接地址',
				type: 'link',
				code: 'link_url'
			}]
		}]
	}, {
		tab: '其他设置',
		content: [{
			label: '标题文字',
			type: 'input',
			code: 'title_text'
		}, {
			label: '标题字号',
			type: 'number',
			code: 'title_size'
		}, {
			label: '更多文字',
			type: 'input',
			code: 'more_text'
		}, {
			label: '跳转路径',
			type: 'link',
			code: 'more_link'
		}]
	}],
	
	img_advert: [{
		tab: '内容设置',
		tips: '注：系统会根据上传的多图进行自动等比例缩放。以下上传的图片最终会显示与一行。最多上传3张图片，注意基础设置中的参数设置。',
		content: [{
			type: 'list',
			code: 'list',
			content: [{
				label: '图片地址',
				type: 'image',
				code: 'img_url',
				widthParam: 'img_width',
				heightParam: 'img_height'
			}, {
				label: '链接地址',
				type: 'link',
				code: 'link_url'
			}]
		}]
	}, {
		tab: '其他设置',
		content: [{
			label: '边距',
			type: 'radio',
			code: 'is_margin',
			options: [{
				name: '保留',
				value: '1'
			}, {
				name: '不保留',
				value: '0'
			}]
		}, {
			label: '分隔间隔',
			type: 'radio',
			code: 'is_padding',
			options: [{
				name: '显示',
				value: '1'
			}, {
				name: '不显示',
				value: '0'
			}]
		}]
	}],
	
	product_recommend: [{
		tab: '内容设置',
		content: PUBLIC_PRODUCT_FILTER_CONFIG()
	}, {
		tab: '其它设置',
		content: [{
			label: '标题栏',
			type: 'group',
			code: 'show_title',
			options: [{
				name: '显示',
				value: '1',
				content: [{
					label: '标题文字',
					type: 'input',
					code: 'title_text'
				}, {
					label: '标题字号',
					type: 'number',
					code: 'title_size'
				}, {
					label: '更多文字',
					type: 'input',
					code: 'more_text'
				}, {
					label: '跳转路径',
					type: 'link',
					code: 'more_link'
				}]
			}, {
				name: '不显示',
				value: '0'
			}]
		}, {
			label: '查看全部',
			type: 'group',
			code: 'show_all',
			options: [{
				name: '显示',
				value: '1',
				content: [{
					label: '跳转路径',
					type: 'link',
					code: 'all_link'
				}]
			}, {
				name: '不显示',
				value: '0'
			}]
		}, {
			label: '每页行数',
			type: 'group',
			code: 'lines',
			options: [{
				name: '1行',
				value: '1'
			}, {
				name: '2行',
				value: '2'
			}]
		}, {
			label: '总页数',
			type: 'hidden',
			code: 'pages',
			value: '3'
		}]
	}],
	
	title: [{
		tab: '内容设置',
		content: [{
			label: '标题文字',
			type: 'input',
			code: 'title_text'
		}, {
			label: '标题字号',
			type: 'number',
			code: 'title_size'
		}, {
			label: '更多文字',
			type: 'input',
			code: 'more_text'
		}, {
			label: '跳转路径',
			type: 'link',
			code: 'more_link'
		}, {
			label: '文字颜色',
			type: 'radio',
			code: 'color',
			options: [{
				name: '深色',
				value: '1'
			}, {
				name: '浅色',
				value: '2'
			}]
		}, {
			label: '额外边距',
			type: 'radio',
			code: 'margin',
			options: [{
				name: '无',
				value: '0'
			}, {
				name: '有',
				value: '1'
			}]
		}]
	}],
	
	video: [{
		tab: '内容设置',
		content: [{
			label: '视频地址',
			type: 'video',
			code: 'video_url'
		}, {
			label: '视频封面',
			type: 'image',
			code: 'image_url'
		}, {
			label: '是否自动播放',
			type: 'radio',
			code: 'auto_play',
			options: [{
				name: '是',
				value: 1
			}, {
				name: '否',
				value: 0
			}]
		}]
	}],
	
	separator: [{
		tab: '内容设置',
		tips: '默认高度为20，填写负数表示向上覆盖',
		content: [{
			label: '留白高度',
			type: 'input',
			code: 'height'
		}]
	}],
	
	channel_banner: [{
		tab: '内容设置',
		tips: '注：所有图片的尺寸需保持一致。',
		content: [{
			type: 'list',
			code: 'list',
			content: [{
				label: '图片地址',
				type: 'image',
				size: '750,0',
				code: 'img_url',
				widthParam: 'img_width',
				heightParam: 'img_height'
			}, {
				label: '链接地址',
				type: 'link',
				code: 'link_url'
			}]
		}]
	}],
	
	channel_product: [{
		tab: '内容设置',
		content: PUBLIC_PRODUCT_FILTER_CONFIG()
	}, {
		tab: '其它设置',
		content: [{
			label: '样式',
			type: 'thumb',
			code: 'style',
			options: [{
				value: 'channel_product_col2_1',
				image: require('@/submodule/assets/image/decorate/thumb/app_channel_product_col2_1.jpg')
			}, {
				value: 'channel_product_col2_2',
				image: require('@/submodule/assets/image/decorate/thumb/app_channel_product_col2_2.jpg')
			}, {
				value: 'channel_product_col1_1',
				image: require('@/submodule/assets/image/decorate/thumb/app_channel_product_col1_1.jpg')
			}, {
				value: 'channel_product_col1_2',
				image: require('@/submodule/assets/image/decorate/thumb/app_channel_product_col1_2.jpg')
			}, {
				value: 'channel_product_col3_1',
				image: require('@/submodule/assets/image/decorate/thumb/app_channel_product_col3_1.jpg')
			}]
		}]
	}]
}

export default config;